<template>
  <div>
    <el-row
      class="flex-container-balance"
      style="padding-bottom: 0px; margin-bottom: 0px"
    >
      <el-col :span="20">
        <el-row type="flex" justify="end">
          <el-col :span="10" :offset="1">
            <el-select
              size="large"
              v-model="proveedor"
              :loading="this.loading_Balance_Data"
              filterable
              clearable
              placeholder="Proveedores"
              @change="GetClintesByEmpresaid"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in proveedores"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-select
              :disabled="!this.proveedor"
              size="large"
              v-model="cliente"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Clientes"
              @change="this.setCliente"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in clientes"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-select
              size="large"
              v-model="year"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Año"
              @change="this.GetDuplicatedTransaccionsAndComprobanteSaltos"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in years"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <template>
        <rabbey-table-3
          class="MargenSuperior"
          :loading="loading"
          :data="tableData"
          :columns="AuditColumns"
        />

        <DrawerAuditoriaTransactions
          :Visible="IsVisible"
          @VisibleFalse="HandleNotVisible"
          :mes="mes"
          :year="year"
          :Day="Dia"
          :proveedor="proveedor"
          :cliente="cliente"
          :descripcion="descripcion"
        ></DrawerAuditoriaTransactions>
        <SaltoComprobanteDrawer
          :visible="detallesSaltoComrpobanteVisible"
          @close="setDetallesSaltoComrpobanteVisible"
          :month="mes"
          :year="year"
          :Total="rowValue"
          :proveedor="proveedor"
        ></SaltoComprobanteDrawer>
        <TransaccionNoRegistradaDrawer
          :Visible="DetallesTransaccionNoRegistradaVisible"
          @VisibleFalse="setDetallesTransaccionNoRegistradaNoVisible"
          :mes="mes"
          :year="year"
          :Day="Dia"
          :proveedor="proveedor"
          :cliente="cliente"
          :descripcion="descripcion"
        ></TransaccionNoRegistradaDrawer>
      </template>
    </el-row>
  </div>
</template>

<script>
import DrawerAuditoriaTransactions from "@/views/modules/audit-transactions/Drawers/DrawerAuditoriaTransactions.vue";
import SaltoComprobanteDrawer from "@/views/modules/audit-transactions/Drawers/SaltoComprobanteDrawer.vue";
import TransaccionNoRegistradaDrawer from "@/views/modules/audit-transactions/Drawers/TransaccionNoRegistradaDrawer.vue";
import { AuditColumns } from "@/views/modules/audit-transactions/AuditColumns.js";
export default {
  name: "Audit",
  components: {
    DrawerAuditoriaTransactions,
    SaltoComprobanteDrawer,
    TransaccionNoRegistradaDrawer
  },
  data() {
    return {
      descripcion: null,
      data1: [],
      data2: [],
      IsVisible: false,
      detallesSaltoComrpobanteVisible: false,
      DetallesTransaccionNoRegistradaVisible: false,
      day: 0,
      tableData: [],
      AuditColumns: AuditColumns,
      cliente: null,
      clientes: [],
      proveedor: 0,
      proveedores: [],
      loading_Balance_Data: false,
      loading1: false,
      mes: new Date().getMonth(),
      loading: false,
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      year: new Date().getFullYear(),
      Dia: new Date().getDay(),
      years: [],
      rowValue: 0
    };
  },

  async mounted() {
    await this.getProveedor();
    this.getYears();
    // await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
  },

  methods: {
    async HandleNotVisible(value) {
      this.IsVisible = value;
      await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },
    OpenDetailsDrawer(mes1, descripcion, value) {
      this.descripcion = descripcion;
      this.mes = mes1;

      this.rowValue = value;
      if (descripcion.toUpperCase() == "SALTO DE COMPROBANTE") {
        this.setDetallesSaltoComrpobanteVisible();
        return;
      }
      if (descripcion == "Transaccion no registrada") {
        this.setDetallesTransaccionNoRegistradaVisible();
        return;
      }
      this.IsVisible = true;
    },

    setDetallesTransaccionNoRegistradaVisible() {
      this.DetallesTransaccionNoRegistradaVisible = true;
    },
    setDetallesTransaccionNoRegistradaNoVisible() {
      this.DetallesTransaccionNoRegistradaVisible = false;
    },
    setDetallesSaltoComrpobanteVisible(visible = true) {
      this.detallesSaltoComrpobanteVisible = visible;
    },
    setCliente() {
      this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },
    setYear() {
      this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },
    getYears() {
      let CurrentYear = new Date().getFullYear();

      for (let i = 2010; i <= CurrentYear; i++) {
        this.years.unshift(i);
      }
    },
    async getProveedor() {
      this.loading_Balance_Data = true;
      this.proveedores.push({ Name: "Todos", id: 0 });
      this.$http
        .get(`/api/tennos/GetEmpresas`)
        .then((resp) => {
          resp.data.forEach((element) => {
            this.proveedores.push({
              Name: element.Name,
              id: element.Empresaid
            });
          });
          this.loading_Balance_Data = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
      await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },
    async GetClintesByEmpresaid() {
      if (this.proveedor != 0) {
        this.loading_Balance_Data = true;
        this.clientes = [];

        this.$http
          .get(`/api/tennos/GetClientByEmpresaId/?EmpresaId=${this.proveedor}`)
          .then((resp) => {
            resp.data.forEach((element) => {
              this.clientes.push({
                Name: element.Nombre_Cliente,
                id: element.clienteid
              });
            });
            this.loading_Balance_Data = false;
          });
      }
      this.cliente = null;
      await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },

    async GetDuplicatedTransaccionsAndComprobanteSaltos() {
      this.tableData = [];
      this.loading = true;

      this.$http
        .get(
          `/api/tennos/GetDuplicatedTransaccionsAndComprobanteSaltos?year=${this.year}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}`
        )
        .then((resp) => {
          // this.tableData.push(this.OpenDetailsDrawer);

          resp.data.forEach(async (element) => {
            element.OpenDetailsDrawer = this.OpenDetailsDrawer;
            element.year = this.year;

            this.tableData.push(element);
          });
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.MargenSuperior {
  margin-top: 3rem;
}
</style>
